/**
 * O título da aba e a impressão das páginas de documento.
 *
 * Papel: aqui fica `useDocumentoPronto`, que dá à aba o título do documento e
 * chama a impressão assim que o documento chega, como a origem fazia 400 ms
 * depois de escrever a janela.
 *
 * Como usar: a página passa `null` enquanto a consulta não volta e o título
 * quando o documento chegou. A impressão sai uma vez só por página aberta,
 * mesmo que o componente rode o efeito duas vezes; imprimir de novo é pelo
 * botão "Imprimir / Salvar PDF".
 */
import { useEffect, useRef } from 'react';

import { useImpressao } from '@/shared/embutido';
import { MARCA_DO_DOCUMENTO } from '../documentos';

/**
 * Dá o título à aba e imprime quando o documento chega.
 *
 * O título anterior da aba volta quando a página sai.
 *
 * @param titulo - `Recibo — <favorecido>` ou `Ordem de Pagamento — <favorecido>`,
 *   que é também o nome que o navegador sugere para o PDF; `null` sem documento.
 */
export function useDocumentoPronto(titulo: string | null) {
  const imprimir = useImpressao(MARCA_DO_DOCUMENTO);
  const impresso = useRef(false);

  useEffect(() => {
    if (titulo === null) return undefined;
    const anterior = document.title;
    document.title = titulo;
    if (!impresso.current) {
      impresso.current = true;
      void imprimir();
    }
    return () => {
      document.title = anterior;
    };
  }, [titulo, imprimir]);
}
